import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Logo from '../components/Logo';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { EnvelopeSimple, ArrowLeft, Check } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [resetToken, setResetToken] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      // For testing, show the token
      if (response.data.reset_token) {
        setResetToken(response.data.reset_token);
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore nel processo');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-8">
        <div className="w-full max-w-md text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check size={32} weight="bold" className="text-green-600" />
          </div>
          <h2 className="text-2xl font-black text-zinc-900 mb-4">Email Inviata</h2>
          <p className="text-zinc-500 mb-6">
            Se l'indirizzo email è registrato, riceverai le istruzioni per reimpostare la password.
          </p>
          
          {/* For testing - show reset link */}
          {resetToken && (
            <div className="bg-zinc-100 border border-zinc-200 p-4 mb-6 text-left">
              <p className="text-xs text-zinc-500 mb-2">Link di reset (per test):</p>
              <Link 
                to={`/reset-password?token=${resetToken}`}
                className="text-sm text-blue-600 hover:underline break-all"
              >
                /reset-password?token={resetToken}
              </Link>
            </div>
          )}

          <Link 
            to="/login" 
            className="text-zinc-900 font-bold hover:underline inline-flex items-center gap-2"
          >
            <ArrowLeft size={18} />
            Torna al login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo size="lg" />
        </div>

        <h2 className="text-2xl font-black text-zinc-900 mb-2 text-center">Password Dimenticata</h2>
        <p className="text-zinc-500 mb-8 text-center">
          Inserisci la tua email per ricevere le istruzioni di reset
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="p-4 bg-red-50 border border-red-200 text-red-700 text-sm">
              {error}
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="email" className="text-sm font-bold uppercase tracking-wider text-zinc-700">
              Email
            </Label>
            <div className="relative">
              <EnvelopeSimple size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="rounded-none border-zinc-300 pl-10"
                placeholder="nome@esempio.com"
                data-testid="forgot-email-input"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full rounded-none bg-zinc-900 hover:bg-zinc-800 text-white font-bold uppercase tracking-wider py-6"
            data-testid="forgot-submit-button"
          >
            {loading ? 'Invio in corso...' : 'Invia Istruzioni'}
          </Button>
        </form>

        <p className="mt-8 text-center">
          <Link to="/login" className="text-zinc-500 hover:text-zinc-900 inline-flex items-center gap-2">
            <ArrowLeft size={18} />
            Torna al login
          </Link>
        </p>
      </div>
    </div>
  );
}
